import styled, {css} from "styled-components";
import {SiteLink} from "nav/SiteLink";
import {authAccentInkCss} from "./LoginModal.styles";

/**
 * The fine-print line above the submit, centred like the login surfaces' other prose lines. It needs no
 * margin of its own: the submit below it brings its own top margin, or sits in a column with a gap.
 */
export const Line = styled.p`
	margin: 0;
	font-size: 12.5px;
	line-height: 1.55;
	color: ${({theme}) => theme.tokens.ink2};
	text-align: center;
`;

/**
 * The look every link in the line shares: underlined accent ink at the sentence's own size.
 *
 * At 12.5px the bare inline box is about 19px tall, under WCAG 2.5.8's 24px minimum. Vertical padding
 * on an inline box does not enter the line height and the negative margin cancels the growth, so the
 * target reaches about 29px while the sentence sets exactly as it would without it.
 */
const inlineLinkCss = css`
	display: inline;
	padding: 5px 3px;
	margin: -5px -3px;
	border: 0;
	background: none;
	font: inherit;
	font-weight: 600;
	${authAccentInkCss};
	text-decoration: underline;
	text-underline-offset: 2px;
	cursor: pointer;

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
		border-radius: 3px;
	}
`;

/**
 * A document name inside the line. A real `<button>`, for the reason {@link terms/Consent.styles} gives:
 * it opens {@link legal/PolicyDialog} instead of navigating, so there is no href to give it, and an `<a>`
 * without one is neither focusable nor operable from the keyboard.
 */
export const DocumentLink = styled.button`
	${inlineLinkCss};
`;

/**
 * The line's link to the pricing page (kitecorp/transferify-ui#3483): a real site link, so it carries the
 * locale tree the visitor is reading through {@link nav/SiteLink}.
 */
export const PlansLink = styled(SiteLink)`
	${inlineLinkCss};
`;
